import React from 'react';
import { Redirect } from 'react-router-dom';
import NotFound from '../components/layout/prevents/NotFound';
import loadable from './loadable';
/**
 * 根目录重定向
 */
const rootRoute = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/home" />,
  },
];

/**
 * 不需要公共头部的路由，在这里做配置
 * 注意：此处如果有嵌套路由，也需要根据情况做通配及重定向配置（参考 innerRoutes）
 */
const outerRoutes = [
  {
    path: '/login',
    component: loadable(() => import('../pages/login')),
    copy: true,
  },
  {
    path: '/register',
    component: loadable(() => import('../pages/register')),
    copy: true,
  },
  {
    path: '/changePwd',
    component: loadable(() => import('../pages/changePwd')),
    copy: true,
  },
  {
    path: '/license',
    component: loadable(() => import('../pages/checkLicense')),
  },
  {
    path: '/orderInfo',
    component: loadable(() => import('../pages/orderInfo')),
    copy: true,
  },
  // {
  //   path: '/saveCart',
  //   component: loadable(() => import('../pages/saveCart')),
  // },
  // {
  //   path: '/saveShortageCart',
  //   component: loadable(() => import('../pages/saveShortageCart')),
  // },
  {
    path: '/savePay',
    component: loadable(() => import('../pages/savePay')),
  },
  {
    path: '/viewSoId',
    component: loadable(() => import('../pages/saveSoId')),
  },
  {
    path: '/cartOrder',
    exact: true,
    component: loadable(() => import('../pages/cartOrder')),
    copy: true,
  },
  {
    path: '/cartOrder/print',
    component: loadable(() => import('../pages/cartOrder/components/Print')),
    copy: true,
  },
  {
    path: '/checkStand',
    component: loadable(() => import('../pages/checkStand')),
    copy: true,
  },
  {
    path: '/paymentStatus',
    component: loadable(() => import('../pages/paymentSuccess')),
  },
  {
    path: '/checkAccountStand',
    component: loadable(() => import('../pages/checkAccountStand')),
    copy: true,
  },
  {
    path: '/survey/fillSurvey',
    component: loadable(() => import('../pages/fillSurvey')),
  },
  {
    path: '/webIm/:selectTab/:selectItem',
    component: loadable(() => import('../pages/webIm')),
  },
  {
    path: '/salesReturn',
    component: loadable(() => import('../pages/salesReturn')),
    routes: [
      {
        path: '/salesReturn',
        exact: true,
        component: () => <Redirect to="/salesReturn/enter" />,
      },
      {
        path: '/salesReturn/enter',
        component: loadable(() => import('../pages/salesReturn/newComponents/index')),
      },
      {
        path: '/salesReturn/check',
        component: loadable(() => import('../pages/salesReturn/Check')),
      },
      {
        path: '/salesReturn/Send',
        component: loadable(() => import('../pages/salesReturn/Send')),
      },
      {
        path: '/salesReturn/receive',
        component: loadable(() => import('../pages/salesReturn/Received')),
      },
      {
        path: '/salesReturn/finish',
        component: loadable(() => import('../pages/salesReturn/Finished')),
      },
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
  {
    path: '/applyAfterSales',
    component: loadable(() => import('../pages/applyAfterSales')),
    routes: [
      {
        path: '/applyAfterSales',
        exact: true,
        component: () => <Redirect to="/applyAfterSales/enter" />,
      },
      {
        path: '/applyAfterSales/enter',
        component: loadable(() => import('../pages/applyAfterSales/newComponents/index')),
      },
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
];

export const hideHeaderRoutes = outerRoutes;

/**
 * 需要有公共头的路由
 */
const innerRoutes = [
  {
    path: '/home',
    component: loadable(() => import('../pages/homepage')),
  },
  {
    path: '/search',
    component: loadable(() => import('../pages/search')),
    // component: loadable(() => import('../pages/search/main')),
    copy: true,
  },
  {
    path: '/wireRod',
    component: loadable(() => import('../pages/wireRod')),
  },
  // {
  //   path: '/industryZone',
  //   exact: true,
  //   component: loadable(() => import('../pages/industryZone')),
  //   copy: true,
  // },
  // {
  //   path: '/industryZone/detail',
  //   component: loadable(() => import('../pages/industryZone/detail')),
  //   copy: true,
  // },
  {
    path: '/specialOrderCenter',
    //exact: true,
    component: loadable(() => import('../pages/orderCenter')),
    copy: true,
    routes: [
      {
        path: '/specialOrderCenter',
        exact: true,
        component: () => <Redirect to="/specialOrderCenter/Detail" />,
      },
      {
        path: '/specialOrderCenter/Detail',
        component: loadable(() => import('../pages/orderCenter/components/SpecialDetail')),
      },
      {
        path: '/orderCenter/returnsRecord',
        exact: true,
        component: loadable(() => import('../pages/orderCenter/components/ReturnsRecord')),
      },
      {
        path: '/orderCenter/saleTotal',
        component: loadable(() => import('../pages/orderCenter/components/SaleTotal')),
      },
      {
        path: '/orderCenter/saleLine',
        component: loadable(() => import('../pages/orderCenter/components/SaleLine')),
      },
      {
        path: '/orderCenter/autoAccount',
        component: loadable(() => import('../pages/orderCenter/components/AutoAccount')),
      },
      {
        path: '/orderCenter/unchecked',
        component: loadable(() => import('../pages/orderCenter/components/Unchecked')),
      },
      {
        path: '/orderCenter/payTogether',
        component: loadable(() => import('../pages/orderCenter/components/PayTogether')),
      },
      {
        path: '/orderCenter/accountDue',
        component: loadable(() => import('../pages/orderCenter/components/AccountDue')),
      },
      {
        path: '/orderCenter/pointOrder',
        component: loadable(() => import('../pages/orderCenter/components/PointOrder')),
      },
      {
        path: '/orderCenter/accountInvoice',
        component: loadable(() => import('../pages/orderCenter/components/AccountInvoice')),
      },
      {
        path: '/orderCenter/wireRecord',
        component: loadable(() => import('../pages/orderCenter/components/WireRecord')),
      },
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
  {
    path: '/orderCenter',
    //exact: true,
    component: loadable(() => import('../pages/orderCenter')),
    copy: true,
    routes: [
      {
        path: '/orderCenter',
        exact: true,
        component: () => <Redirect to="/orderCenter/detail" />,
      },
      {
        path: '/orderCenter/detail',
        component: loadable(() => import('../pages/orderCenter/components/Detail')),
      },
      {
        path: '/orderCenter/returnsRecord',
        exact: true,
        component: loadable(() => import('../pages/orderCenter/components/ReturnsRecord')),
      },
      {
        path: '/orderCenter/saleTotal',
        component: loadable(() => import('../pages/orderCenter/components/SaleTotal')),
      },
      {
        path: '/orderCenter/saleLine',
        component: loadable(() => import('../pages/orderCenter/components/SaleLine')),
      },
      {
        path: '/orderCenter/autoAccount',
        component: loadable(() => import('../pages/orderCenter/components/AutoAccount')),
      },
      {
        path: '/orderCenter/unchecked',
        component: loadable(() => import('../pages/orderCenter/components/Unchecked')),
      },
      {
        path: '/orderCenter/payTogether',
        component: loadable(() => import('../pages/orderCenter/components/PayTogether')),
      },
      {
        path: '/orderCenter/accountDue',
        component: loadable(() => import('../pages/orderCenter/components/AccountDue')),
      },
      {
        path: '/orderCenter/pointOrder',
        component: loadable(() => import('../pages/orderCenter/components/PointOrder')),
      },
      {
        path: '/orderCenter/accountInvoice',
        component: loadable(() => import('../pages/orderCenter/components/AccountInvoice')),
      },
      {
        path: '/orderCenter/wireRecord',
        component: loadable(() => import('../pages/orderCenter/components/WireRecord')),
      },
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
  {
    path: '/specialOffer',
    component: loadable(() => import('../pages/specialOffer')),
  },
  {
    path: '/customDemand',
    component: loadable(() => import('../pages/customDemand')),
    copy: true,
    routes: [
      {
        path: '/customDemand',
        exact: true,
        component: () => <Redirect to="/customDemand/page" />,
      },
      {
        path: '/customDemand/page',
        exact: true,
        component: loadable(() => import('../pages/customDemand/page')),
      },
      {
        path: '/customDemand/add',
        exact: true,
        component: loadable(() => import('../pages/customDemand/add')),
      },
      {
        path: '/customDemand/myDemandList',
        exact: true,
        component: loadable(() => import('../pages/customDemand/myDemandList')),
      },
      {
        path: '/customDemand/detail',
        exact: true,
        component: loadable(() => import('../pages/customDemand/detail')),
      },
    ],
  },
  // {
  //   path: '/customCode',
  //   component: loadable(() => import('../pages/customCode')),
  //   routes: [
  //     {
  //       path: '/customCode',
  //       exact: true,
  //       component: () => <Redirect to="/customCode/order" />,
  //     },
  //     {
  //       path: '/customCode/order',
  //       exact: true,
  //       component: loadable(() => import('../pages/customCode/components/Order')),
  //     },
  //     {
  //       path: '/customCode/management',
  //       exact: true,
  //       component: loadable(() => import('../pages/customCode/components/Management')),
  //     },
  //   ],
  // },
  // {
  //   path: '/favorite',
  //   component: loadable(() => import('../pages/favorite')),
  // },
  {
    path: '/quicklyOrder',
    component: loadable(() => import('../pages/quickLyOrder')),
    copy: true,
    routes: [
      {
        path: '/quicklyOrder',
        exact: true,
        component: () => <Redirect to="/quicklyOrder/customCode" />,
      },
      {
        path: '/quicklyOrder/customCode',
        component: loadable(() => import('../pages/customCode')),
        routes: [
          {
            path: '/quicklyOrder/customCode',
            exact: true,
            component: () => <Redirect to="/quicklyOrder/customCode/order" />,
          },
          {
            path: '/quicklyOrder/customCode/order',
            exact: true,
            component: loadable(() => import('../pages/customCode/components/newOrder')),
          },
          {
            path: '/quicklyOrder/customCode/management',
            exact: true,
            component: loadable(() => import('../pages/customCode/components/Management')),
          },
        ],
      },
      {
        path: '/quicklyOrder/favorite',
        exact: true,
        component: loadable(() => import('../pages/favorite')),
      },
    ],
  },
  {
    path: '/specialQuicklyOrder',
    component: loadable(() => import('../pages/quickLyOrder')),
    copy: true,
    routes: [
      {
        path: '/specialQuicklyOrder',
        exact: true,
        component: () => <Redirect to="/specialQuicklyOrder/customCode" />,
      },
      {
        path: '/specialQuicklyOrder/customCode',
        component: loadable(() => import('../pages/customCode')),
        routes: [
          {
            path: '/specialQuicklyOrder/customCode',
            exact: true,
            component: () => <Redirect to="/specialQuicklyOrder/customCode/management" />,
          },
          {
            path: '/specialQuicklyOrder/customCode/management',
            exact: true,
            component: loadable(() => import('../pages/customCode/components/Management')),
          },
        ],
      },
      {
        path: '/specialQuicklyOrder/favorite',
        exact: true,
        component: loadable(() => import('../pages/favorite')),
      },
    ],
  },
  {
    path: '/profile',
    copy: true,
    component: loadable(() => import('../pages/profile')),
    routes: [
      {
        path: '/profile',
        exact: true,
        component: () => <Redirect to="/profile/memberInfo" />,
      },
      {
        path: '/profile/memberInfo',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Basic')),
      },
      {
        path: '/profile/memberAddressInfo',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Address')),
      },
      {
        path: '/profile/itemApplication',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Application')),
      },
      {
        path: '/profile/memberRedPacket',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Discount')),
      },
      {
        path: '/profile/memberCoupon',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Discount')),
      },
      {
        path: '/profile/memberArrivalRem',
        exact: true,
        component: loadable(() => import('../pages/profile/components/RemindList')),
      },
      {
        path: '/profile/memberArrivalSug',
        exact: true,
        component: loadable(() => import('../pages/profile/components/RemarkList')),
      },
      {
        path: '/profile/bi',
        exact: true,
        component: loadable(() => import('../pages/profile/components/BI')),
      },
      {
        path: '/profile/report',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Report')),
      },
      {
        path: '/profile/historical',
        exact: true,
        component: loadable(() => import('../pages/profile/components/HistoricalSheet')),
      },
      {
        path: '/profile/stock',
        exact: true,
        component: loadable(() => import('../pages/profile/components/Stock')),
      },
      {
        path: '/profile/discount',
        exact: true,
        component: loadable(() => import('../pages/profile/components/DiscountSheet')),
      },
      {
        path: '/profile/defaultMcu',
        exact: true,
        component: loadable(() => import('../pages/profile/components/DefaultMcu')),
      },
    ],
  },
  {
    path: '/notification',
    copy: true,
    component: loadable(() => import('../pages/notification')),
    routes: [
      {
        path: '/notification/:pacCode',
        exact: true,
        component: loadable(() => import('../pages/notification/components/List')),
      },
      {
        path: '/notification/:pacCode/detail',
        component: loadable(() => import('../pages/notification/components/Detail')),
      },
      {
        path: '/notification/:pacCode/:acCode',
        exact: true,
        component: loadable(() => import('../pages/notification/components/List')),
      },
      {
        path: '/notification/:pacCode/:acCode/detail',
        component: loadable(() => import('../pages/notification/components/Detail')),
      },
      {
        path: '/notification/:_pacCode/:pacCode/:acId',
        component: loadable(() => import('../pages/notification/components/Detail')),
      },
      {
        path: '*',
        component: NotFound,
      },
    ],
  },
  {
    path: '/cart',
    copy: true,
    component: loadable(() => import('../pages/cart/index')),
  },
  {
    path: '/settleAccount',
    component: loadable(() => import('../pages/settleAccount/index')),
  },
  {
    path: '/saleSettleAccount',
    component: loadable(() => import('../pages/saleSettleAccount/index')),
  },
  // {
  //   path: '/feedback',
  //   copy: true,
  //   component: loadable(() => import('../pages/feedback')),
  // },
  {
    path: '/afterSales',
    component: loadable(() => import('../pages/afterSales')),
    copy: true,
    routes: [
      {
        path: '/afterSales',
        exact: true,
        component: () => <Redirect to="/afterSales/feedback" />,
      },
      {
        path: '/afterSales/feedback',
        exact: true,
        component: loadable(() => import('../pages/afterSales/FeedbackHome')),
      },
      {
        path: '/afterSales/feedbackAdd',
        exact: true,
        component: loadable(() => import('../pages/afterSales/FeedbackAdd')),
      },
      {
        path: '/afterSales/feedbackRecord',
        exact: true,
        component: loadable(() => import('../pages/afterSales/FeedbackRecord')),
      },
      {
        path: '/afterSales/feedbackDetail',
        exact: true,
        component: loadable(() => import('../pages/afterSales/FeedbackDetail')),
      },
      {
        path: '/afterSales/detectionRecord',
        exact: true,
        component: loadable(() => import('../pages/afterSales/detectionRecord')),
      },
      {
        path: '/afterSales/detectionDetail',
        exact: true,
        component: loadable(() => import('../pages/afterSales/detectionDetail')),
      },
      {
        path: '/afterSales/detectionEdit',
        exact: true,
        component: loadable(() => import('../pages/afterSales/detectionEdit')),
      },
      // {
      //   path: '/afterSales/returnsRecord',
      //   exact: true,
      //   component: loadable(() => import('../pages/afterSales/ReturnsRecord')),
      // },
    ],
  },
  {
    path: '/download',
    copy: true,
    component: loadable(() => import('../pages/download')),
    routes: [
      {
        path: '/download/:code',
        component: loadable(() => import('../pages/download/components/List')),
        exact: true,
      },
    ],
  },
  {
    path: '/application',
    copy: true,
    component: loadable(() => import('../pages/application')),
  },
  {
    path: '/activityArea',
    component: loadable(() => import('../pages/promotionZone')),
    routes: [
      {
        path: '/activityArea',
        exact: true,
        component: () => <Redirect to="/activityArea/act" />,
      },
      {
        path: '/activityArea/act',
        exact: true,
        component: loadable(() => import('../pages/promotionZone/components/Activity')),
      },
      // {
      //   path: '/activityArea/draw',
      //   exact: true,
      //   component: loadable(() => import('../pages/promotionZone/components/Lottery')),
      // },
      {
        path: '/activityArea/coupon',
        exact: true,
        component: loadable(() => import('../pages/promotionZone/components/Coupon')),
      },
      {
        path: '/activityArea/assoc',
        exact: true,
        component: loadable(() => import('../pages/promotionZone/components/TieinSale')),
      },
    ],
  },
  {
    path: '/activityZone',
    component: loadable(() => import('../pages/activityZone')),
    copy: true,
    routes: [
      {
        path: '/activityZone',
        exact: true,
        component: () => <Redirect to="/activityZone/specialOffer" />,
      },
      {
        path: '/activityZone/specialOffer',
        exact: true,
        component: loadable(() => import('../pages/specialOffer')),
      },
      {
        path: '/activityZone/intoInstantRebate',
        exact: true,
        component: loadable(() => import('../pages/moneyOff')),
      },
      {
        path: '/activityZone/flashSales',
        exact: true,
        component: loadable(() => import('../pages/flashSales')),
      },
      {
        path: '/activityZone/draw',
        exact: true,
        component: loadable(() => import('../pages/promotionZone/components/Lottery')),
      },
      {
        path: '/activityZone/multiRebate',
        exact: true,
        component: loadable(() => import('../pages/moneyOffMulti')),
      },
      {
        path: '/activityZone/industryZone',
        exact: true,
        component: loadable(() => import('../pages/industryZone')),
        // copy: true,
      },
      {
        path: '/activityZone/industryZone/detail',
        exact: true,
        component: loadable(() => import('../pages/industryZone/detail')),
        // copy: true,
      },
    ],
  },

  {
    path: '/finance',
    component: loadable(() => import('../pages/finance')),
    routes: [
      {
        path: '/finance/turnkey',
        exact: true,
        meta: {
          name: '周转通',
        },
        component: loadable(() => import('../pages/finance/components/Turnover')),
      },
      {
        path: '/finance/myturnover',
        exact: true,
        meta: {
          name: '我的周转通',
        },
        component: loadable(() => import('../pages/finance/components/MyTurnover')),
      },
      {
        path: '/finance/suiningPost',
        exact: true,
        meta: {
          name: '随宁贴',
        },
        component: loadable(() => import('../pages/finance/components/Suining')),
      },
      {
        path: '/finance/easyLoan',
        exact: true,
        meta: {
          name: '分销通',
        },
        component: loadable(() => import('../pages/finance/components/EasyLoan')),
      },
      {
        path: '/finance/myEasyLoan',
        exact: true,
        meta: {
          name: '我的分销通',
        },
        component: loadable(() => import('../pages/finance/components/MyEasyLoan')),
      },
    ],
  },

  {
    path: '*',
    component: NotFound,
  },
];

const routesConfig = [...rootRoute, ...outerRoutes, ...innerRoutes];

export default routesConfig;
